
export const pumpedgabo = {
  content: {
    allRightsReserved: "Minden jog fenntartva.",
    loading: "Betöltés...",
    notFound: "A keresett tartalom nem található.",
    backToList: "Vissza a tartalomlistához",
    readyToStart: "Készen állsz a kezdésre?",
    purchaseDescription: "Vásárold meg most ezt a tartalmat, és azonnal hozzáférsz minden anyaghoz.",
    purchaseNow: "Vásárlás most",
    detailedDescription: "Részletes leírás",
    whatIncludes: "Mit tartalmaz",
    features: "Jellemzők",
    buy: "Megvásárlom",
    package: {
      title: "Exkluzív Pumped Gabo csomagok",
      description: "Válogass a speciálisan összeállított tartalomcsomagjaim közül"
    },
    personalMeeting: {
      title: "Személyes találkozás Pumped Gaboval",
      subtitle: "Egyéni edzés és mentorálás",
      description: "Élj át egy átalakító személyes találkozást, ahol közvetlenül megosztom veled a fitnesz szaktudásomat és zen filozófiámat."
    }
  },
  chat: {
    sendMessage: "Küldd el az üzeneted",
    price: "Egy üzenet ára: {price} Ft",
    rules: "Szabályzat",
    ruleRespect: "Kérjük, fogalmazz tisztelettudóan",
    ruleSpam: "Kerüld a spam jellegű üzeneteket",
    ruleLength: "Maximum {maxLength} karakter hosszú lehet az üzenet",
    ruleResponse: "{days} napon belül válaszolok",
    message: "Üzenet",
    messagePlaceholder: "Írd ide a kérdésed...",
    characters: "karakter",
    proceedToPayment: "Tovább a fizetéshez ({price} Ft)",
    errorEmptyMessage: "Kérlek, írd be az üzeneted",
    errorTooLong: "Az üzenet nem lehet hosszabb {maxLength} karakternél"
  },
  media: {
    title: "Média megjelenések",
    viewArticle: "Megtekintés"
  },
  workshop: {
    title: "Zen Workshopok Pumped Gaboval",
    subtitle: "Fedezd fel a belső harmóniát",
    description: "Exkluzív workshopok, ahol a testépítés és a zen filozófia találkozik",
    benefits: "Előnyök",
    includes: "Mit tartalmaz",
    relatedWorkshops: "További workshopok",
    register: "Jelentkezés a workshopra",
    bookingPolicy: "Jelentkezéseddel elfogadod a workshopra vonatkozó feltételeket és szabályokat",
    filterAll: "Összes",
    filterBeginner: "Kezdő",
    filterIntermediate: "Középhaladó",
    filterAdvanced: "Haladó",
    searchPlaceholder: "Keresés a workshopok között...",
    notFound: "Nincs találat a keresési feltételeknek megfelelően",
    showAllButton: "Összes workshop megtekintése",
    faq: {
      title: "Gyakori kérdések",
      equipment: {
        question: "Milyen felszerelést kell hoznom a workshopra?",
        answer: "Csak kényelmes ruhát és esetleg egy jógamatracot vagy ülőpárnát érdemes hoznod. Minden más szükséges eszközt mi biztosítunk. Ha van kedvenc meditációs eszközöd, természetesen azt is elhozhatod."
      },
      experience: {
        question: "Szükséges korábbi tapasztalat a részvételhez?",
        answer: "Nem szükséges korábbi tapasztalat. A workshopjaink minden szinten elérhetők, a teljesen kezdőktől a tapasztaltabbakig. A gyakorlatokat mindenki a saját szintjéhez tudja igazítani."
      },
      refund: {
        question: "Lemondhatom a foglalást, ha mégsem tudok részt venni?",
        answer: "Igen, a workshop időpontja előtt 72 órával még teljes visszatérítést biztosítunk. Ezen időpont után a befizetett összeg 50%-át tudjuk visszatéríteni. 24 órán belüli lemondás esetén sajnos nem áll módunkban visszatérítést biztosítani."
      },
      preparation: {
        question: "Hogyan készüljek fel a workshopra?",
        answer: "Érdemes a workshop előtti napon korán lefeküdni és kipihenten érkezni. A workshop előtt 2 órával már ne egyél nehéz ételt, és a foglalás után küldünk néhány rövid olvasnivalót, amit érdemes előre átnézni."
      }
    }
  },
  services: {
    workoutPlans: {
      title: "Edzéstervek",
      description: "Személyre szabott és általános edzéstervek, melyekben megosztom a kondi pápa tapasztalataimat, hatékony gyakorlatokat és a testi fejlődéshez szükséges tippeket."
    },
    thoughtDiscussion: {
      title: "Gondolatébresztő Párbeszéd",
      description: "Oszd meg velem gondolataidat, kérdéseidet az egészséges életmódról, a zenéről vagy a fenntarthatóságról. Szívesen megosztom veled a saját tapasztalataimat."
    },
    personalVideo: {
      title: "Személyes Videoüzenet",
      description: "Egy személyre szabott videóüzenetben megoszthatom veled motivációs gondolataimat, vagy közvetíthetek egy különleges üzenetet egy számodra fontos embernek."
    },
    communityMeetings: {
      title: "Közösségi Találkozások",
      description: "Virtuális találkozások, ahol együtt fedezhetjük fel a testmozgás, az önfejlesztés, a zen filozófia és a környezettudatosság útjait, megosztva egymással tapasztalatainkat."
    },
    personalMeeting: {
      title: "Személyes Találkozás",
      description: "Különleges alkalom, amikor személyesen találkozhatsz velem, akár edzés, DJ fellépés vagy természeti elvonulás formájában. Egyedi élmény, amely során közvetlen kapcsolatba kerülhetsz velem."
    },
    personalCoaching: {
      title: "Személyes Találkozás",
      description: "Egyéni beszélgetés és edzés velem személyesen. Tapasztalataim és szemléletem megosztása, amely segít számodra megtalálni az egyensúlyt a test, az elme és a környezettudatos életmód között."
    },
    experiencePackages: {
      title: "Élménycsomagok",
      description: "Összefüggő élményeken keresztül fedezheted fel a testépítés, a zen filozófia és az ökotudatos életmód különböző aspektusait, mindent egy helyen."
    }
  }
};
